<template>
  <div>
    <label :class="valid === false ? 'red--text': ''">{{ field.label }}</label>
    <vue-tel-input
      valid-characters-only
      :value="newValue"
      default-country="FR"
      mode="international"
      :preferred-countries="['FR']"
      :input-options="{
        placeholder:'000 000 000'
      }"
      style="margin-bottom: 13px"
      @input="($event) => { newValue = $event} "
      @validate="($event) => { valid = $event.valid} "
    />
    <!-- @validate="handleValidation" -->
  </div>
</template>
<script>
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
  name: 'PhoneNumberField',
  components: { VueTelInput },
  props: {
    value: {
      type: String,
      default: ''
    },
    field: {
      type: Object,
      default: () => {}
    }
  },
  data: function () {
    return {
      newValue: this.$props.value,
      valid: false,
      componentType: 'v-text-field'
    };
  },
  watch: {
    newValue (val) { // Updates v-model on the parent
      this.$emit('input', val);
    },
    valid (val) {
      this.$emit('update:valid', val);
    }
  },
  methods: {}

};
</script>
